import React, { useEffect, useRef, Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Watch } from "react-loader-spinner";
import { ApiService } from '../../containers/Services/apiservice';
let apiServices = new ApiService();

const CompleteProfile = () => {
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [states, setState] = useState([]);
    const [IsMinor, setIsMinor] = useState(0);
    const [city, setCity] = useState([]);
    const [imageproof, setImageproof] = useState({ preview: '', raw: '', name: '' });
    const [image, setImage] = useState({ preview: '', raw: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const [profileData, setProfileData] = useState({ dob: '', fname: '', lname: '', pan: '', addr1: '', addr2: '', city: '', state: '', pin: '', addrtype: '' });
    let history = useHistory();
    useEffect(() => {
        const dataString = {
        }
        apiServices.getUserData(dataString).then(result => {
            if (result.data.status == 'success') {
                setProfileData({
                    fname: result.data.data.gs_fname,
                    lname: result.data.data.gs_lname,
                    dob: result.data.data.gs_dob,
                    pan: result.data.data.gs_pan_no,
                    addr1: result.data.data.gs_address1,
                    pin: result.data.data.gs_pin,
                    city: result.data.data.gs_city,
                    state: result.data.data.gs_state,
                    addrtype: result.data.data.gs_address_proof_type
                });
                setImage({
                    preview: result.data.data.gs_pan_image,
                    raw: 'update',
                    name: result.data.data.gs_pan_image.split('/').pop()
                });
                setImageproof({
                    preview: result.data.data.gs_address_proof,
                    raw: 'update',
                    name: result.data.data.gs_address_proof.split('/').pop()
                });
                handleInput();
            } else if (result.data.status == 'error' && result.data.message == 'Session expired') {
                history.push("/login");
            }
        })
    }, []);
    const getCities = (value) => {
        const dataString = {
            "id": value
        }
        apiServices.getcities(dataString).then(res => {
            if (res.data.status == 'success') {
                setCity(res.data.data);
                return;
            }
        })
    }
    const handleChange = (e) => {
        if (e.target.files.length) {
            if (e.target.name == 'panimg') {
                setImage({
                    preview: URL.createObjectURL(e.target.files[0]),
                    raw: e.target.files[0],
                    name: e.target.files[0].name
                });
            }
            else if (e.target.name == 'uploadaadhar') {
                setImageproof({
                    preview: URL.createObjectURL(e.target.files[0]),
                    raw: e.target.files[0],
                    name: e.target.files[0].name
                });
            }
        }
    };
    const handleInput = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        setProfileData({ ...profileData, [key]: value })
        if (key == 'addrtype') {
            displayImage(value);
        }
        if (key == 'state') {
            getCities(value);
        }
    }
    const displayImage = (e) => {
        if (e == 0) {
            document.getElementById("arrdproofimg").style.display = "none";
        }
        else {
            document.getElementById("arrdproofimg").style.display = "";
        }
        // document.getElementById("panimg").click()
    }
    const upload = (e) => {
        document.getElementById("panimg").click()
    }
    const uploadaadhar = (e) => {
        document.getElementById("uploadaadhar").click()
    }
    const removeimage = (e) => {
        setImage('');
    }
    const removeimageaddrproof = (e) => {
        setImageproof('');
    }
    const thirdStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (profileData.addr1 == '' || profileData.city == '' || profileData.pin == '' || profileData.addr1 == null || profileData.city == null || profileData.pin == null) {
            setErrorMessage("All Fields Are Mandatory");
            setSpinnerLoading(false);
        }
        // else if (imageproof.name=='' || imageproof.name==null || imageproof.name=="") {
        //     setErrorMessage("Address Proof is Required");
        //     setSpinnerLoading(false);
        //     return ;
        // }
        else {
            setErrorMessage('');
            const formData = new FormData();
            formData.append('step', '3');
            formData.append('addr1', profileData.addr1);
            formData.append('addr2', profileData.addr2);
            formData.append('city', profileData.city);
            formData.append('state', profileData.state);
            formData.append('pin', profileData.pin);
            formData.append('addrtype', profileData.addrtype);
            formData.append('addrproof', imageproof.raw);
            apiServices.completeprofile(formData).then(result => {
                if (result.data.status == 'success') {
                    // localStorage.setItem('user', JSON.stringify(res.data.data));
                    var a = document.getElementById("active3");
                    a.setAttribute("class", "active");
                    if (result.data.canstatus == 0) {
                        history.push("/canregister");
                    }
                    else {
                        history.push("/bankdetails");
                    }
                    setImage({
                        preview: '',
                        raw: ''
                    });
                    setSpinnerLoading(false);
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    localStorage.removeItem('AUTH_TOKEN');
                    // alert(result.data.message)
                    setSpinnerLoading(false);
                    history.push("/login")
                }
                else {
                    setErrorMessage(result.data.message);
                    setSpinnerLoading(false);
                }
                // setShowLoading(false);
            })
                .catch(error => {
                })
        }
    };
    const secondStep = (e) => {
        e.preventDefault();
        if ((profileData.pan == '' || profileData.pan == null) && IsMinor == 0) {
            setErrorMessage("PAN is Required");
            setSpinnerLoading(false);
            return;
        }
        else if ((profileData.pan.length != 10) && IsMinor == 0) {
            setErrorMessage("Invalid PAN");
            setSpinnerLoading(false);
            return;
        }
        else if (profileData.dob == '' || profileData.dob == null) {
            setErrorMessage("Date Of Birth is Required");
            setSpinnerLoading(false);
            return;
        }
        else {
            setErrorMessage('');
        }
        setSpinnerLoading(true);
        const formData = new FormData();
        setTimeout(() => {
            formData.append('pan_img', image.raw);
            formData.append('pan', profileData.pan);
            formData.append('step', '2');
            formData.append('dob', profileData.dob);
            // if (profileData.pan=='' || profileData.pan==null ) {
            //     setErrorMessage("PAN is Required");
            //     setSpinnerLoading(false);
            //     return;
            // }
            // else if (profileData.pan.length != 10 ) {
            //     setErrorMessage("Invalid PAN");
            //     setSpinnerLoading(false);
            //     return;
            // } 
            // else if (profileData.dob=='' || profileData.dob==null ) {
            //     setErrorMessage("Date Of Birth is Required");
            //     setSpinnerLoading(false);
            //     return;
            // } 
            // else {
            // alert('aa');
            // setErrorMessage('');
            if (IsMinor == 1) {
                formData.append('minor', IsMinor);
                formData.append('can_status', 0);
                processstep2(formData);
            } else {
                apiServices.canfetch(formData).then(result => {
                    if (result.data.respStatus === '1') {
                        formData.append('can_status', 0);
                        processstep2(formData);
                    }
                    else if (result.data.respStatus === '0') {
                        if (result.data.canFetchRes.canStatus == 'AP') {
                            formData.append('can_status', 1);
                            formData.append('can_number', result.data.canFetchRes.can);
                            processstep2(formData);
                        } else if (result.data.canFetchRes.canStatus == 'PE' || result.data.canFetchRes.canStatus == 'OH') {
                            formData.append('can_status', 2);
                            formData.append('can_number', result.data.canFetchRes.can);
                            processstep2(formData);
                        } else if (result.data.canFetchRes.canStatus == 'SU') {
                            setErrorMessage('Your CAN Status Is Suspended Please Contact Goalstox Customer Support');
                            setSpinnerLoading(false);
                            return false;
                        } else if (result.data.canFetchRes.canStatus == 'DR') {
                            setErrorMessage('Your CAN Status Is Dormant Please Contact Goalstox Customer Support');
                            setSpinnerLoading(false);
                            return false;
                        }
                        else if (result.data.status == "error" && result.data.message == "Session expired") {
                            localStorage.removeItem('AUTH_TOKEN');
                            // alert(result.data.message)
                            setSpinnerLoading(false)
                            history.push("/login")
                        }
                        else {
                            alert(result.data.message)
                            return false
                        }
                    }
                    // else{
                    //     // alert('aasdd')
                    //     if(result.data.errorCode == 'apiserviceerror.900144')
                    //     {
                    //         formData.append('can_status',0);
                    //             processstep2(formData);             
                    //     }
                    //     else{
                    //     setErrorMessage(result.data.errorMessage);
                    //     setSpinnerLoading(false);
                    //     return false;
                    //     } 
                    // }
                })
            }
            return false;
            // }
        }, 1000);

    };
    const processstep2 = (formData) => {
        apiServices.completeprofile(formData).then(result => {
            if (result.data.status == 'success') {
                // localStorage.setItem('user', JSON.stringify(res.data.data));
                var a = document.getElementById("active2");
                a.setAttribute("class", "active");
                setStep1(false)
                setStep2(false)
                setStep3(true)
                setState(result.data.statedata);
                setCity(result.data.citydata);
                setImage({
                    preview: '',
                    raw: ''
                });
                setSpinnerLoading(false);
            }
            else {
                setErrorMessage(result.data.message);
                setSpinnerLoading(false);
            }
            // setShowLoading(false);
        })
            .catch(error => {

            })
    }
    const firstStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);

        if (profileData.fname == '' || profileData.lname == '' || profileData.fname == null || profileData.lname == null) {
            setErrorMessage("These Fields Cannot Be Empty");
            setSpinnerLoading(false);
        } else {
            setErrorMessage('');
            const dataString = {
                "step": 1,
                "fname": profileData.fname,
                "lname": profileData.lname
            }
            apiServices.completeprofile(dataString).then(result => {
                if (result.data.status == 'success') {
                    // localStorage.setItem('user', JSON.stringify(res.data.data));
                    var a = document.getElementById("active1");
                    a.setAttribute("class", "active");
                    setStep1(false)
                    setStep2(true)
                    setStep3(false)
                    setSpinnerLoading(false);
                }
                else if (result.data.status == "error" && result.data.message == "Session expired") {
                    // alert(result.data.message)
                    history.push("/login")
                    localStorage.removeItem('AUTH_TOKEN');
                    setSpinnerLoading(false);
                }
                else {
                    setErrorMessage(result.data.message);
                    setSpinnerLoading(false);
               }
                // setShowLoading(false);
            })
                .catch(error => {
                })
        }
    };
    return (
        <div>
            <Header />
            <Helmet>
                <title>CompleteProfile - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            <div className="step-process">
                <ul>
                    <li id="active1"></li>
                    <li id="active2"></li>
                    <li id="active3"></li>
                </ul>
            </div>
            <section>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                {step1 == true ?
                    <div id="step1" className="container">
                        <div className="login-media align-items-stretch justify-content-center ht-100p">
                            <div className="sign-wrapper">
                                <div className="wd-100p">
                                    <h6 className="tx-color-03">Step 1 of 3</h6>
                                    <h5>Let's Create Your Profile</h5>
                                    <p className="tx-color-03 mg-b-30  tx-13">Your name will be taken as per (PAN Card)</p>
                                    <div className="form-group">
                                        <label>First Name<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="text" name="fname" value={profileData.fname} onChange={handleInput} className="form-control" />
                                    </div>
                                    <div className="form-group">
                                        <label>Last Name<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="text" name="lname" value={profileData.lname} onChange={handleInput} className="form-control" />
                                        <span id="show_validation" className="text text-danger"></span>
                                   </div>
                                    {
                                        errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                    }
                                    <button type="submit" className="btn btn-success button01" onClick={firstStep}><span id="loader" style={{ display: 'none' }}><img src="https://www.codexo.in/goalstox/admin/public/frontend-assets/assets/img/loader.gif" style={{ width: '20px' }} /></span><span id="signin">Continue</span></button>
                                </div>
                            </div>
                           <div className="login-media-img d-none align-items-center d-lg-flex">
                                <div className="mx-wd-600">
                                    <img src="img/User-Profile-Details.jpg" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
               {step2 == true ?
                    <div id="step2" className="container">
                        <div className='col-12'>
                            <div className="alert alert-danger tx-14 d-flex align-items-center" role="alert">
                                If KYC is not done, Kindly get your eKYC done here.
                                <a href="https://go.goalstox.com/kyc" target="new" class="buttonab-line-3 ml-auto">Start Now <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <div className="login-media align-items-stretch justify-content-center ht-100p">
                            <div className="sign-wrapper">
                                <div className="wd-100p">
                                    <h6 className="tx-color-03">Step 2 of 3</h6>
                                    <h5>Let's Create Your Profile</h5>
                                    <p className="tx-color-03 mg-b-30  tx-13">Your name will be taken as per (PAN Card)</p>
                                    <div className="form-group">
                                        <label>Investor Type<span style={{ color: '#ff0000' }}>*</span></label>
                                        <select className="form-control" name="state" value={IsMinor} onChange={(e) => setIsMinor(e.target.value)} >
                                            <option value="0">Individual</option>
                                            <option value="1">Minor</option>
                                        </select>
                                    </div>
                                    {IsMinor == 0 ?
                                        <div className="form-group">
                                            <label>PAN<span style={{ color: '#ff0000' }}>*</span></label>
                                            <input type="text" name="pan" value={profileData.pan} onChange={handleInput} id="pan" className="form-control" placeholder="" maxLength="10" style={{ textTransform: 'uppercase' }} />
                                        </div> : ''}
                                    <div className="form-group">
                                        <label>Date Of Birth<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="date" name="dob" value={profileData.dob} onChange={handleInput} id="dob" className="form-control" />
                                    </div>

                                    {/* <div className="form-group"> 
                                <div className="document-image">
                                 
                                <input type="file" name="panimg" id="panimg" style={{display:'none'}} onChange={handleChange} />     */}
                                    {/* { image.name == '' || image.name == undefined ? 
                                   <div>   
                                   <span onClick={upload}>Upload Pancard (Pdf/Jpg/Png)</span>
                                   <span onClick={upload} className='ml-auto'><img src="img/upload.png"></img></span> 
                                   </div>
                                :
                                <div>
                                <span onClick={upload}>{image.name}</span>
                                <span onClick={removeimage} className='ml-auto'><img src="img/trash.png"></img></span> </div>  
                                } */}
                                    {/* </div>
                            </div> */}
                                    {
                                        errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                    }
                                    <button className="btn btn-success button01" onClick={secondStep}><span id="loader2" style={{ display: 'none' }}><img src="https://www.codexo.in/goalstox/admin/public/frontend-assets/assets/img/loader.gif" style={{ width: '20px' }} /></span><span id="signin2">Continue</span></button>
                                </div>
                            </div>
                           <div className="login-media-img d-none align-items-center d-lg-flex">
                                <div className="mx-wd-600">
                                    <img src="img/User-panDetails.jpg" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
                {step3 == true ?
                    <div id="step3" className="container">
                        <div className="login-media align-items-stretch justify-content-center ht-100p">
                            <div className="sign-wrapper-second">
                                <div className="wd-100p">
                                    <h6 className="tx-color-03">Step 3 of 3</h6>
                                    <h5>Let's Create Your Profile</h5>
                                    <p className="tx-color-03 mg-b-30  tx-13">Enter your address details & proof</p>
                                    <div className="form-group">
                                        <label>Address<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="text" name="addr1" value={profileData.addr1} onChange={handleInput} className="form-control" placeholder="" />
                                    </div>
                                    <div className="form-group" style={{ display: 'none' }}>
                                        <label>Country<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="text" value='India' className="form-control" placeholder="" />
                                    </div>
                                    <div className="row">
                                        <div className="form-group col lg-6">
                                            <label>State<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select className="form-control" name="state" value={profileData.state} onChange={handleInput} >
                                                <option value="0">Select State</option>
                                                {states.map(key =>
                                                    <option value={key.state_id}>{key.state_name}</option>
                                                )
                                                }
                                            </select>
                                        </div>
                                        <div className="form-group col lg-6">
                                            <label>City<span style={{ color: '#ff0000' }}>*</span></label>
                                            <select className="form-control" value={profileData.city} onChange={handleInput} name="city">
                                                <option value="0">Select City</option>
                                                {city.map(key =>
                                                    <option value={key.cities_id}>{key.cities_name}</option>
                                                )
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Postcode<span style={{ color: '#ff0000' }}>*</span></label>
                                        <input type="number" name="pin" value={profileData.pin} onChange={handleInput} className="form-control" placeholder="" />
                                    </div>
                                    {/* <div className="form-group">
                                <label>Address Proof</label>
                                <select className="form-control" name="addrtype" value={profileData.addrtype} onChange={handleInput}>
                                        <option value="0">Select Address Proof</option>
                                        <option value="Aadhar">Aadhar</option>
                                        <option value="Driving License">Driving License</option>
                                        <option value="Passport">Passport</option>
                                        <option value="Voter ID">Voter ID</option>
                                  </select>
                                </div> */}

                                    {/* <div className="form-group" id = "arrdproofimg">
                            <div className="document-image">
                            <input type="file" name="uploadaadhar" id="uploadaadhar" style={{display:'none'}} onChange={handleChange}/>    
                           
                           
                            { imageproof.name == '' || imageproof.name == undefined ? 
                                   <div>   
                                   <span onClick={uploadaadhar}>Upload Address Proof (Pdf/Jpg/Png)</span>
                                   <span onClick={uploadaadhar} className='ml-auto'><img src="img/upload.png"></img></span> 
                                   </div>
                            :
                         
                             <div>
                             <span onClick={uploadaadhar}>{imageproof.name}</span>
                             <span onClick={removeimageaddrproof} className='ml-auto'><img src="img/trash.png"></img></span> </div>  
                            } */}

                                    {/* <img  src="img/upload-image.png" className="img-fluid" alt=""  onClick={uploadaadhar}/>           */}

                                    {/* { imageproof.preview != "" ? 
                            <img  src={imageproof.preview} className="img-fluid" alt="" onClick={uploadaadhar}/>
                            :   
                            <img  src="img/upload-image.png" className="img-fluid" alt=""  onClick={uploadaadhar}/>          
                            } */}
                                    {/* </div>

                            </div> */}
                                    {
                                        errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                    }
                                    <button className="btn btn-success button01" onClick={thirdStep}><span id="loader3" style={{ display: 'none' }}><img src="https://www.codexo.in/goalstox/admin/public/frontend-assets/assets/img/loader.gif" style={{ width: '20px' }} /></span><span id="signin3">Continue</span></button>
                                </div>
                            </div>
                            <div className="login-media-img d-none align-items-center d-lg-flex">
                                <div className="mx-wd-600" id="userdetailsimage">
                                    <img src="img/User-Profile-Details.jpg" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
            </section>
            <Footer />
        </div>
    );
}

export default CompleteProfile;